import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { IState } from '../../../../../store/index';
import { archive } from '../../../../../store/popups/remove';
import { RequestReview, IRequestReviewProps } from './index';

type TStoreProps = Pick<IRequestReviewProps, 'agent'>;
type TDispatchProps = Pick<IRequestReviewProps, 'onSubmit'>;

function mapStateToProps(state: IState): TStoreProps {
  return {
    agent: state.offerData.agent,
  };
}

function mapDispatchToProps(dispatch: Dispatch<IState>): TDispatchProps {
  return {
    onSubmit: () => dispatch(archive()),
  };
}

export const RequestReviewContainer = connect<TStoreProps, TDispatchProps>(
  mapStateToProps,
  mapDispatchToProps,
)(RequestReview);
